import { getStoredChatId } from "./cloud-storage"
import { parseStartParams } from "./parse-start-params"

import type { StartParams } from "./parse-start-params"

export interface ResolvedTelegramRouteContext {
  chatId: number | null
  shareToken: string | null
  startParamChatId: number | null
}

export const resolveTelegramRouteContext = async (
  startParams: StartParams = parseStartParams(),
  logScope = "RouterContext"
): Promise<ResolvedTelegramRouteContext> => {
  const { chatId: startParamChatId, shareToken } = startParams

  let chatId = startParamChatId

  if (chatId === null) {
    try {
      const result = await getStoredChatId()

      if (result.status === "error") {
        console.warn(`[${logScope}] CloudStorage error:`, result.error)
      }

      if (result.status === "success") {
        chatId = result.value
      }
    } catch (error: unknown) {
      console.warn(`[${logScope}] CloudStorage read failed:`, error)
    }
  }

  return {
    chatId,
    shareToken,
    startParamChatId
  }
}
